import { createStore } from 'vuex'
import hear from './modules/hear'
import popover from './modules/popover'
import init from './modules/init'

export default createStore({
  state: {
    selectIndex: 0,
    menuIndex: localStorage.getItem('menuIndex') || null,
    activeIndex: localStorage.getItem('activeIndex') || null,
    user_info: JSON.parse(localStorage.getItem('user_info')) || {},
    app_id: JSON.parse(localStorage.getItem('app_id')) || null,
    showMenusApplicationConfig: JSON.parse(localStorage.getItem('showMenusApplicationConfig')) || {},
    isMenuLoaded: false,
  },
  getters: {
  },
  mutations: {
    EDITSELECTINDEX: (state,selectIndex) => {
      state.selectIndex = selectIndex
    },
    CHANGESELECTINDEX: (state,selectMenuIndex) => {
      state.menuIndex = selectMenuIndex
      localStorage.setItem('menuIndex',selectMenuIndex)
    },
    ACTIVEINDEX: (state,activeIndex) => {
      state.activeIndex = activeIndex
      localStorage.setItem('activeIndex',activeIndex)
    },
    USERINFO : (state,user_info) => {
      state.user_info = user_info
      localStorage.setItem('user_info',JSON.stringify(user_info))
    },
    APPID : (state,app_id) => {
      state.app_id = app_id
      localStorage.setItem('app_id',JSON.stringify(app_id))
    },
    showMenusApplicationConfig : (state,showMenusApplicationConfig) => {
      state.showMenusApplicationConfig = showMenusApplicationConfig
      localStorage.setItem('showMenusApplicationConfig',JSON.stringify(showMenusApplicationConfig)) 
    },
    isMenuLoaded : (state,isMenuLoaded) => {
      state.isMenuLoaded = isMenuLoaded
    }
  },
  actions: {
    editSelectIndex({commit},selectIndex){
      commit('EDITSELECTINDEX',selectIndex)
    },
    changeSelectMenu({commit},selectMenuIndex){
      commit('CHANGESELECTINDEX',selectMenuIndex)
    },
    activeIndex({ commit },activeIndex){
      commit('ACTIVEINDEX', activeIndex)
    },
    saveUserInfo({commit},user_info){
      commit('USERINFO',user_info)
    },
    app_id({commit},app_id){
      commit('APPID',app_id)
    },
    showMenusApplicationConfig({commit},showMenusApplicationConfig){
      commit('showMenusApplicationConfig',showMenusApplicationConfig) 
    },
    isMenuLoaded({commit}){
      commit('isMenuLoaded',true) 
    }
  },
  modules: {
    hear,
    popover,
    init
  }
})
